import { createBlockSignal } from '@core/block';

export const isScrollingToMessage = createBlockSignal<boolean>(false);
